"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTgLogo = function SvgTgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.67 12.352c-.726.675-1.446 1.339-2.16 2.008-.249.234-.53.364-.887.346-.244-.013-.381-.115-.456-.336-.547-1.618-1.101-3.232-1.645-4.852-.053-.157-.13-.233-.298-.282A366.421 366.421 0 0 1 1.37 8.088a2.244 2.244 0 0 1-.568-.25C.538 7.669.5 7.392.736 7.192c.218-.185.479-.345.75-.448 1.573-.595 3.156-1.17 4.736-1.751L18.25.564c.762-.281 1.348.115 1.27.901-.052.503-.188.998-.298 1.494-.871 3.921-1.742 7.842-2.618 11.762-.208.93-.893 1.174-1.696.609-1.345-.946-2.689-1.894-4.033-2.841-.064-.045-.131-.088-.204-.137Zm-3.019 1.19.046-.01c.008-.037.02-.073.024-.11.086-.889.177-1.777.252-2.667a.642.642 0 0 1 .245-.473c1.24-1.057 2.472-2.121 3.707-3.183 1.367-1.176 2.734-2.35 4.096-3.531.084-.073.12-.197.177-.298-.128-.013-.266-.062-.382-.033-.159.04-.31.127-.451.212-3.017 1.812-6.031 3.628-9.05 5.436-.17.103-.202.19-.137.368.222.61.425 1.225.635 1.84l.838 2.45Z",
    fill: "#fff"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTgLogo);
var _default = exports["default"] = Memo;